export const ERROR_MESSAGES = {
  // Auth
  UNAUTHORIZED: 'Zaloguj się ponownie',
  ITEM_NOT_FLIPPABLE: 'Tego przedmiotu nie da się odwrócić',
  NAME_TAKEN: 'To imię jest już zajęte — wybierz inne',
  INVALID_NAME: 'Imię nie może być puste',
  INVALID_CREDENTIALS: 'Złe imię lub hasło',

  // House
  HOUSE_ALREADY_UNLOCKED: 'Dom jest już otwarty',
  INSUFFICIENT_MONEY_FOR_UNLOCK: 'Potrzebujesz 20 {coin} żeby odblokować dom',

  // Shop
  INSUFFICIENT_MONEY: 'Za mało pieniążków {coin}',
  INVALID_QUANTITY: 'Ilość musi być większa od zera',

  // Furniture
  UNKNOWN_FURNITURE: 'Tego mebla nie ma w sklepie',
  FURNITURE_ALREADY_OWNED: 'Już masz ten mebel',
  INSUFFICIENT_MONEY_FOR_FURNITURE: 'Za mało pieniążków na ten mebel {coin}',

  // Rooms
  UNKNOWN_ROOM: 'Takiego pokoju nie ma',
  ROOM_ALREADY_UNLOCKED: 'Ten pokój jest już odblokowany',
  INSUFFICIENT_MONEY_FOR_ROOM: 'Za mało pieniążków na ten pokój {coin}',

  // Sub-project A — placements
  ITEM_NOT_IN_UNPLACED_INVENTORY: 'Nie masz tego w szufladzie do postawienia',
  INVALID_SCENE: 'W tej scenie nie można niczego postawić',
  PLACEMENT_LIMIT_REACHED: 'Tu już nic więcej się nie zmieści',
  BUDA_SCENE_NOT_ALLOWED: 'Tej budy nie można postawić w tej scenie',
  FURNITURE_SCENE_NOT_ALLOWED: 'Mebli nie można stawiać na zewnątrz',
  PLACEMENT_NOT_ON_FLOOR: 'To musi stać na podłodze {chair}',
  PLACEMENT_NOT_ON_WALL: 'To wisi na ścianie {picture}',
  PLACEMENT_NOT_FOUND: 'Nie ma takiego postawionego przedmiotu',
  INVALID_COORDINATES: 'Złe miejsce do postawienia',
  // Buda
  UNKNOWN_BUDA: 'Takiej budy nie ma w sklepie',
  INSUFFICIENT_MONEY_FOR_BUDA: 'Za mało pieniążków na budę {coin}',
  // Animal
  UNKNOWN_ANIMAL: 'Takiego zwierzaka nie ma',
  INSUFFICIENT_MONEY_FOR_ANIMAL: 'Za mało pieniążków na zwierzaka {coin}',
  ANIMAL_LIMIT_REACHED_IN_SCENE: 'Zagroda jest pełna — więcej zwierząt się tu nie zmieści {cow}',
  BUDA_LIMIT_REACHED: 'Zagroda jest pełna — ta zagroda stałaby pusta {cow}',
  POCKET_FULL: 'Za dużo zwierząt już czeka — najpierw postaw budę {house}',
  ANIMAL_NOT_FOUND: 'Nie ma takiego zwierzaka',
  NO_FOOD: 'Nie masz odpowiedniej karmy. Kup w sklepie zwierząt!',
  NO_PENDING_PRODUCT: 'Nic do zebrania jeszcze',
  ANIMAL_DOES_NOT_PRODUCE: 'To zwierzątko nie produkuje jedzonka',
  // Food
  UNKNOWN_FOOD: 'Takiej karmy nie ma',
  INSUFFICIENT_MONEY_FOR_FOOD: 'Za mało pieniążków na karmę {coin}',
  // Product
  UNKNOWN_PRODUCT: 'Takiego produktu nie ma',
  INSUFFICIENT_PRODUCTS: 'Nie masz tylu produktów do sprzedania',
  // Clothing
  UNKNOWN_CLOTHING: 'Takiego ciucha nie ma',
  INSUFFICIENT_MONEY_FOR_CLOTHING: 'Za mało pieniążków na ten ciuch {coin}',
  CLOTHING_ALREADY_OWNED: 'Już masz ten ciuch',
  CLOTHING_NOT_OWNED: 'Nie masz tego ciucha — kup w sklepie',
  INVALID_CATEGORY: 'Nie ma takiej kategorii ubrań',

  // Sub-project B
  HOUSE_AT_MAX_LEVEL: 'Dom jest już na maksymalnym poziomie {castle}',
  INSUFFICIENT_MONEY_FOR_UPGRADE: 'Za mało pieniążków na ulepszenie domu {coin}',
  HOUSE_LOCKED: 'Najpierw otwórz dom {lock}',
  BACKYARD_ALREADY_UNLOCKED: 'Podwórko jest już otwarte',
  BACKYARD_LOCKED: 'Podwórko jest zamknięte {lock}',
  BACKYARD_AT_MAX_LEVEL: 'Podwórko jest już na maksymalnym poziomie {yard}',
  INSUFFICIENT_MONEY_FOR_BACKYARD: 'Za mało pieniążków na podwórko {coin}',

  // Board games (Salon Gier counter shop)
  UNKNOWN_BOARD_GAME: 'Nie ma takiej gry',
  BOARD_GAME_ALREADY_OWNED: 'Masz już tę grę',
  BOARD_GAME_NOT_AVAILABLE: 'Ta gra będzie dostępna wkrótce',
  INSUFFICIENT_MONEY_FOR_BOARD_GAME: 'Za mało pieniędzy na tę grę {coin}',

  // Network/generic
  NETWORK: 'Sprawdź połączenie z internetem {wifi}',
  SERVER: 'Serwer ma chwilkę, spróbuj jeszcze raz',
  UNKNOWN: 'Coś poszło nie tak',

  // Driving school
  DRIVING_NO_COURSE: 'Najpierw zapisz się na kurs {note}',
  DRIVING_COURSE_ALREADY_BOUGHT: 'Już jesteś zapisany na kurs',
  INSUFFICIENT_MONEY_FOR_DRIVING: 'Za mało pieniążków {coin}',
  DRIVING_COOLDOWN: 'Następne podejście dopiero jutro {hourglass}',
  DRIVING_SESSION_ACTIVE: 'Masz już rozpoczęty test',
  DRIVING_NO_SESSION: 'Nie ma rozpoczętego testu',
  DRIVING_ALREADY_PASSED: 'Ten egzamin już zdałeś {party}',
  DRIVING_BAD_ANSWER: 'Ups, coś się pomyliło z odpowiedzią',
  DRIVING_NO_THEORY: 'Najpierw zdaj egzamin teoretyczny {grad_cap}',
  DRIVING_LESSON_ORDER: 'Zrób lekcje po kolei',
  DRIVING_LESSONS_DONE: 'Lekcje już zaliczone {check}',
  DRIVING_LESSONS_MISSING: 'Najpierw zrób 3 lekcje praktyczne',
  DRIVING_TOO_FAST: 'To było za szybko — przejedź trasę do końca',

  // Cars — HTTP actions (/api/actions/cars/*)
  CAR_NO_LICENCE: 'Najpierw zrób prawo jazdy {licence}',
  CAR_NO_SLOT: 'Nie masz miejsca w garażu — ulepsz podwórko {yard}',
  CAR_UNKNOWN_MODEL: 'Takiego auta nie ma w salonie',
  CAR_NOT_FOUND: 'To nie jest Twoje auto',
  CAR_BROKEN: 'Auto jest zepsute — napraw je w serwisie {wrench}',
  CAR_NOT_BROKEN: 'To auto jest sprawne {thumbs_up}',
  CAR_NOT_HERE: 'Auto jest gdzie indziej',
  CAR_IS_ELECTRIC: 'To auto elektryczne — ładuje się w domu {plug}',
  CAR_BAD_FUEL: 'Takiego paliwa nie ma na stacji',
  INSUFFICIENT_MONEY_FOR_CAR: 'Za mało pieniążków {coin}',
  CAR_BAD_REPORT: 'Ups, coś nie gra z licznikiem',
  CAR_NOT_YET: 'Auto jeszcze jedzie',
  // Cars — realtime (`car_error` over the socket)
  CAR_SEATS_FULL: 'W tym aucie nie ma już miejsca {car}',
  CAR_MOVING: 'Poczekaj, aż auto się zatrzyma',
  CAR_NOT_DRIVING: 'Tym autem nikt nie jedzie',
  CAR_ALREADY_IN: 'Już siedzisz w aucie',
};

export function messageFor(err) {
  const code = err?.detail?.error_code ?? err?.error_code;
  return ERROR_MESSAGES[code] ?? err?.detail?.message ?? err?.message ?? ERROR_MESSAGES.UNKNOWN;
}
